import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const travelPricingServiceCalculationSettingsEntity: Entity = {
  model: model,
  repository: repository,
}

export default travelPricingServiceCalculationSettingsEntity
